import React,{useState,useEffect} from "react";
import { isMobile } from "react-device-detect";
import MbpAthnTknCrtRqstApi from 'Apis/MbpAthnTknCrtRqstApi';

const MbpAthnUi = ({athnPrpsCd,AthnTxt,loginId,ChkFunc,BtnClass,smsNtfyRecvYnRef}:any) => {
    const [mbpAthnTkn,setMbpAthnTkn] = useState("");
    const reqKMCISForm:any = document.getElementById('reqKMCISForm');
    const reqTr_cert:any = document.getElementById('tr_cert');
    let mbpAthnTknVal:any
    var KMCIS_window;
    const MbpAthnTknCrtRqstFunc = (e:any) => {
        
        const reqTr_cert:any = document.getElementById('tr_cert');
        e.preventDefault();
        if(ChkFunc!=null) {
            const shouldStop = ChkFunc();
            if(shouldStop) {
                return; // 체크 함수에서 중단 신호를 보내면 여기서 종료
            }
        }
        switch(athnPrpsCd){
            case"PWD_RSET":
            case "PWD_RSET_MYPAGE":
            MbpAthnTknCrtRqstApi(athnPrpsCd,loginId).then((resp) => {
                reqTr_cert.value =resp.apiBody.kmcTkn;
            }).then((resp)=>{
                openKMCISWindow();
            });
            break;
            case "MTHD_CHNG":
              MbpAthnTknCrtRqstApi(athnPrpsCd,loginId,smsNtfyRecvYnRef?.current ?? null).then((resp) => {
                 reqTr_cert.value =resp.apiBody.kmcTkn;
            }).then((resp)=>{
                openKMCISWindow();
            });
            break;
            // case"PWD_RSET":
            // MbpAthnTknCrtRqstApi(athnPrpsCd,loginId).then((resp) => {
            //     reqTr_cert.value =resp.kmcTkn;
            // }).then((resp)=>{
            //     openKMCISWindow();
            // });
            // break;
            // case"MEMB_LVD":
            // MbpAthnTknCrtRqstApi(athnPrpsCd,loginId).then((resp) => {
            //     reqTr_cert.value =resp.kmcTkn;
            // }).then((resp)=>{
            //     openKMCISWindow();
            // });
            // break;
            default:
            MbpAthnTknCrtRqstApi(athnPrpsCd,null).then((resp) => {
                reqTr_cert.value =resp.apiBody.kmcTkn;
                
            }).then((resp)=>{
                openKMCISWindow();
            });
            break;
        }
    }
    function openKMCISWindow (){
        const reqKMCISForm:any = document.getElementById('reqKMCISForm');
        if(isMobile == true) {
            reqKMCISForm.target = '';
        }else {
            KMCIS_window = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
            
            if(KMCIS_window == null){
                alert(" ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.");
            }
            reqKMCISForm.target = 'KMCISWindow';
        };
        reqKMCISForm.action = 'https://www.kmcert.com/kmcis/web/kmcisReq.jsp';
        reqKMCISForm.submit();
    }
    return (
        <div>
            <form id="reqKMCISForm" method="post" name="reqKMCISForm" action="#">          
                <input type="hidden" id="tr_cert" className="tr_cert" value={mbpAthnTkn} name="tr_cert"/>
                <input type="hidden" className="tr_url" value={process.env.REACT_APP_KMC_REDIRECT_URL}  name="tr_url"/>
                <input type="hidden" value={"V2"}      name="tr_ver"/>
                <button type="submit" className={BtnClass !=null?BtnClass:<></>} onClick={MbpAthnTknCrtRqstFunc}>
                     <p>{AthnTxt}</p>
                </button>
            </form>
        </div>
    )
}

// gameSvcCd 설정이 필요한 경우를 위한 확장된 컴포넌트
const MbpAthnUiWithGameSvcCd = ({athnPrpsCd, AthnTxt, loginId, ChkFunc, BtnClass, gameSvcCd, onGameSvcCdSet}:any) => {
    const [mbpAthnTkn,setMbpAthnTkn] = useState("");
    const reqKMCISForm:any = document.getElementById('reqKMCISForm');
    const reqTr_cert:any = document.getElementById('tr_cert');
    let mbpAthnTknVal:any
    var KMCIS_window:any ;
    
    const MbpAthnTknCrtRqstFunc = (e:any) => {
        const reqTr_cert:any = document.getElementById('tr_cert');
        e.preventDefault();
        
        // gameSvcCd 설정 콜백 호출
        if(onGameSvcCdSet && gameSvcCd) {
            onGameSvcCdSet(gameSvcCd);
        }
        
        if(ChkFunc!=null) {
            const shouldStop = ChkFunc();
            if(shouldStop) {
                return;
            }
        }
        
        switch(athnPrpsCd){
            case"PWD_RSET":
            MbpAthnTknCrtRqstApi(athnPrpsCd,loginId).then((resp) => {
                reqTr_cert.value =resp.apiBody.kmcTkn;
            }).then((resp)=>{
                openKMCISWindow();
            });
            break;
            case "MTHD_CHNG":
            MbpAthnTknCrtRqstApi(athnPrpsCd,loginId).then((resp) => {
                 reqTr_cert.value =resp.apiBody.kmcTkn;
            }).then((resp)=>{
                openKMCISWindow();
            });
            break;
            default:
            MbpAthnTknCrtRqstApi(athnPrpsCd,loginId).then((resp) => {
                reqTr_cert.value =resp.apiBody.kmcTkn;
            }).then((resp)=>{
                openKMCISWindow();
            });
        }
    };
    
    const openKMCISWindow = () => {
        if(isMobile) {
            reqKMCISForm.target = '';
        }else{
            KMCIS_window = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
            if(KMCIS_window == null){
                alert('팝업 차단 기능이 설정되어있습니다. 팝업 차단 기능을 해제한 후 다시 시도해주세요.');
            }
            reqKMCISForm.target = 'KMCISWindow';
        };
        reqKMCISForm.action = 'https://www.kmcert.com/kmcis/web/kmcisReq.jsp';
        reqKMCISForm.submit();
    }
    
    return (
        <div>
            <form id="reqKMCISForm" method="post" name="reqKMCISForm" action="#">          
                <input type="hidden" id="tr_cert" className="tr_cert" value={mbpAthnTkn} name="tr_cert"/>
                <input type="hidden" className="tr_url" value={process.env.REACT_APP_KMC_REDIRECT_URL}  name="tr_url"/>
                <input type="hidden" value={"V2"}      name="tr_ver"/>
                <button type="submit" className={BtnClass !=null?BtnClass:<></>} onClick={MbpAthnTknCrtRqstFunc}>
                     <p>{AthnTxt}</p>
                </button>
            </form>
        </div>
    )
}

export default MbpAthnUi;
export { MbpAthnUiWithGameSvcCd };